import React from "react";

const MarketScope = () => {
  const categories = [
    {
      title: "Product",
      items: [
        "Medical devices",
        "Service",
        "Cardiology",
        "Ophthalmic",
        "Dental",
        "Product",
      ],
    },
    {
      title: "Technology",
      items: ["Medical", "Robotics", "Edge Computing"],
    },
    {
      title: "End Use",
      items: ["End Use", "End Use", "End Use", "End Use", "End Use", "End Use"],
    },
    {
      title: "Region",
      items: ["Region", "Region", "Region", "Region", "Region", "Region"],
    },
    {
      title: "Countries",
      items: [
        "Countries",
        "Countries",
        "Countries",
        "Countries",
        "Countries",
        "Countries",
      ],
    },
  ];

  return (
    <div className=" bg-white rounded-lg p-6 shadow border1 font-inter">
      <h2 className="text-xl font-bold mb-4 font4">
        Spatial genomics & transcriptomics market scope
      </h2>

      <div className="overflow-auto h-96 w-full custom-scrollbar">
        <div className="flex w-full space-x-4">
          {" "}
          {categories.map((category, idx) => (
            <div key={idx} className="flex-shrink-0 w-[20%]">
              <button className="block w-full bg-[#dd517c] text-white px-4 py-2 font-bold underline text-lg rounded-md mb-2 mt-2 ">
                <span className="relative z-10">{category.title}</span>
              </button>

              <div className=" w-full space-y-2">
                {" "}
                {category.items.map((item, itemIdx) => (
                  <button
                    key={itemIdx}
                    className="block w-full font17 border border4 px-4 py-2 hover:bg-gray-200 rounded-md"
                    onClick={() => alert(`${item} clicked`)}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketScope;
